import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import styled from 'styled-components';
import ImageGallery from '../components/ImageGallery';
import { apartmentsData } from '../data/apartments';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DetailsContainer = styled.div`
  padding: 8rem 0 4rem;
  background: ${props => props.theme.colors.white};
`;

const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
`;

const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 4rem;
`;

const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const PriceBox = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.08);
  border: 1px solid #eee;
`;

const ApartmentInfo = styled.div`
  margin: 25px 0;
  font-size: 1.1rem;
  color: #666;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;

  span {
    font-weight: 500;
  }
`;

const ContactBox = styled.div`
  margin-top: 2rem;
  background: ${props => props.theme.gradients.primary};
  color: white;
  padding: 2rem;
  border-radius: 16px;
`;

const ContactButton = styled(Link)`
  display: inline-block;
  margin-top: 1rem;
  background: white;
  color: ${props => props.theme.colors.primary};
  padding: 12px 20px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
`;

const ApartmentDetails = () => {

  const { id } = useParams();
  const apartment = apartmentsData.find(a => a.id === parseInt(id));

  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [guests, setGuests] = useState('');

  if (!apartment) return <div>Apartament nie znaleziony</div>;

  const maxGuests = apartment.id === 1 ? 6 : 4;

  const deluxePrices = {
    1: 270,
    2: 310,
    3: 390,
    4: 420,
    5: 490,
    6: 530
  };

  const standardPrices = {
    1: 230,
    2: 290,
    3: 340,
    4: 360
  };

  let nights = 0;

  if (startDate && endDate) {
    nights = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
  }

  let pricePerNight = 0;

  if (guests) {
    pricePerNight = apartment.id === 1
      ? deluxePrices[guests]
      : standardPrices[guests];
  }

  let totalPrice = pricePerNight * nights;

  if (nights >= 7) {
    totalPrice = totalPrice * 0.95;
  }

  return (
    <DetailsContainer>

      <Container>

        <ImageGallery
          images={apartment.images}
          apartmentName={apartment.name}
        />

        <ApartmentInfo>

          <span>{apartment.specs.area}</span>

          <span>maks. {apartment.specs.guests}</span>

          <span>{apartment.specs.rooms}</span>

          <span>{apartment.specs.floor}</span>

        </ApartmentInfo>

        <ContentGrid>

          <div>

            <h2>Opis apartamentu</h2>

            <p>{apartment.description}</p>

            <p>{apartment.longDescription}</p>

            <ContactBox>

              <h3>Zarezerwuj teraz</h3>

              <p>
                Skontaktuj się z nami aby sprawdzić dostępność
                i zarezerwować apartament.
              </p>

              <ContactButton to="/contact">
                Skontaktuj się
              </ContactButton>

            </ContactBox>

          </div>

          <Sidebar>

            <PriceBox>

              <h3>Sprawdź cenę</h3>

              <DatePicker
                selectsRange
                startDate={startDate}
                endDate={endDate}
                onChange={(update) => setDateRange(update)}
                minDate={new Date()}
                inline
              />

              <div style={{ marginTop: "1rem" }}>

                <label>Goście</label>

                <select
                  value={guests}
                  onChange={(e) => setGuests(Number(e.target.value))}
                >

                  <option value="">Wybierz</option>

                  {[...Array(maxGuests)].map((_, i) => (
                    <option key={i} value={i + 1}>
                      {i + 1}
                    </option>
                  ))}

                </select>

              </div>

              {guests && startDate && endDate && (

                <h2 style={{ marginTop: "1rem" }}>
                  {Math.round(totalPrice)} zł
                </h2>

              )}

            </PriceBox>

          </Sidebar>

        </ContentGrid>

      </Container>

    </DetailsContainer>
  );

};

export default ApartmentDetails;